import { toast } from 'react-toastify';

import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '~/services/api';

import { getStartEventSuccess, getStartEventFailure } from './actions';
import {
  IGetStartEventRequestAction,
  IActivitiesTypes,
  IStartEvent,
} from './types';

export function* getStartEvent({ payload }: IGetStartEventRequestAction): any {
  const { id } = payload;

  try {
    const response = yield call(
      api.get,
      `/activities/history/start-event/${id}`,
    );
    const startEvent = response.data as IStartEvent;

    yield put(getStartEventSuccess(startEvent));
  } catch (err) {
    yield put(getStartEventFailure());
    toast.error('Erro ao buscar abertura da solicitação');
  }
}

export default all([
  takeLatest(IActivitiesTypes.GET_START_EVENT_REQUEST, getStartEvent),
]);
